import { Injectable } from "@angular/core";
import { WindowRefService } from "../../../../services/window-ref.service";

@Injectable()
export class ShortSearchParamsAnalyticsService {
  constructor(private windowService: WindowRefService) {}

  trackCalendarOpen(place: string) {
    this.track("click_calendar_open", {
      Place: place,
    });
  }

  trackTouristsOpen() {
    this.track("click_tourists_open");
  }

  trackModalAfterShow(event: string, payload?: Record<string, unknown>) {
    if (event) {
      this.track(event, payload);
    }
  }

  trackCalendarApply() {
    this.track("click_apply_in_calendar");
  }

  trackTouristsApply(adults: number, childAges: number[]) {
    this.track("сlick_apply_tourists_count", {
      adults,
      child: childAges.length,
      childAges,
    });
  }

  private track(eventName: string, payload?: Record<string, unknown>) {
    this.windowService.nativeWindow.brxTracking.sendAnalyticsEvent(eventName, payload);
  }
}
